import { ContentHoverPopover } from '@ui/content-hover-popover';
import { ICultureParamData } from '@@/agriculture/ts';
import styles from './index.module.sass';

export function AgricultureHintParameters(props: IAgricultureHintParametersProps) {
  const { params, children } = props;

  if ((!params || params.length === 0) && children) return children;

  return (
    <ContentHoverPopover
      content={
        <table className={styles.root}>
          <tbody>
            {params.map((p) => (
              <tr key={p.name}>
                <td>{p.name}</td>
                <td>
                  {p.value}
                  {p.units}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      }
    >
      {children}
    </ContentHoverPopover>
  );
}

export interface IAgricultureHintParametersProps {
  children?: JSX.Element;
  params: Array<ICultureParamData>;
}
